import type { sortingOrder } from '@utils/productList';

const productListDefaultSettings = {
  defaultSortingOrder: 'relevance_desc' as sortingOrder,
  isFilterOverlayShown: false,
  productsPerPage: 50,
  sortingOptions: [
    {
      label: 'Relevanz',
      value: 'relevance_desc' as sortingOrder
    },
    {
      label: 'Niedrigster Preis',
      value: 'price_asc' as sortingOrder
    },
    {
      label: 'Höchster Preis',
      value: 'price_desc' as sortingOrder
    },
    {
      label: 'Neuerscheinungen',
      value: 'new_arrivals_desc' as sortingOrder
    },
    {
      label: 'Bestseller',
      value: 'score_top_seller_desc' as sortingOrder
    },
    {
      label: 'Kundenbewertung',
      value: 'user_rating_desc' as sortingOrder
    },
    {
      label: 'Angebote',
      value: 'discount_desc' as sortingOrder
    }
  ]
};

export default productListDefaultSettings;
